var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0v10H8.762L4 14v-4H0V0h14zm-1 1H1v8h4v2.853L8.397 9H13V1z",
    fill: "param(fill)",
    fillRule: "nonzero"
  })));
}

export default "data:image/svg+xml,%3csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3e90EE158C-3A34-41AF-9416-06F2471C6355@1x%3c/title%3e %3cg id='collections' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Select-Media---commented' transform='translate(-311.000000, -377.000000)' fill='param(fill)' fill-rule='nonzero'%3e %3cg id='2' transform='translate(296.000000, 229.000000)'%3e %3cg id='comment-shaddow' transform='translate(8.000000, 143.000000)'%3e %3cg id='comment-shaddow' transform='translate(7.000000, 4.000000)'%3e %3cg id='Rectangle-Copy' transform='translate(0.000000, 1.000000)'%3e %3cpath d='M14,0 L14,10 L8.76153564,10 L4,14 L4,10 L0,10 L0,0 L14,0 Z M13,1 L1,1 L1,9 L5,9 L5,11.853 L8.39724472,9 L13,9 L13,1 Z'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgComment as ReactComponent };